import { createContext, useContext } from "react";

export interface SSRData {
  product?: any;
  seoData?: any;
  auction?: any;
  catalogPage?: { products: any[]; total: number };
}

export const SSRDataContext = createContext<SSRData>({});

export function useSSRData(): SSRData {
  return useContext(SSRDataContext);
}
